export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PHONE_DISPLAY = "+971 50 274 0497";
export const PHONE_TEL = "tel:+971502740497";
export const EMAIL = "cs@reefdeco.com";
export const WHATSAPP_URL = "https://wa.me/971502740497";

export const FALLBACK_FABRICS = [
  { id: "sheer", name: "Premium Sheer", rate: 85, desc: "Light & breezy, softly filtered glow" },
  { id: "blackout", name: "Total Blackout", rate: 120, desc: "Complete darkening & thermal insulation" },
  { id: "linen", name: "Natural Linen", rate: 100, desc: "Textured organic weave, elegant drape" },
  { id: "velvet", name: "Royal Velvet", rate: 140, desc: "Plush luxury with rich depth" },
  { id: "roller", name: "Roller Blinds", rate: 95, desc: "Sleek UV-reflective protection" },
  { id: "roman", name: "Roman Blinds", rate: 110, desc: "Tailored folds, architectural finish" },
];

export const MOTOR_COST = 450;
export const MIN_ORDER_TOTAL = 500;

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
